/**
 * Per-package tender / RFQ service (v3_50) — surfaces the backend tender subsystem.
 * BV routes are authenticated; the public vendor routes are token-gated (no login).
 * Axios interceptor returns response.data bare.
 */
import axiosInstance from "../api/axios";

/* ---------------- BV (authenticated) ---------------- */
export const createTender = (body) => axiosInstance.post(`/interior/tenders`, body);
export const listStageTenders = (planStageId) =>
  axiosInstance.get(`/interior/execution-plan/stages/${planStageId}/tenders`);
export const getTender = (tenderId) => axiosInstance.get(`/interior/tenders/${tenderId}`);
// showAll (move-in service tenders): bypass the local/intercity gate to list every move-in vendor.
export const getTenderVendorMatches = (tenderId, showAll = false) =>
  axiosInstance.get(`/interior/tenders/${tenderId}/vendor-matches`, {
    params: showAll ? { showAll: true } : {},
  });
export const setTenderVendors = (tenderId, vendorIds) =>
  axiosInstance.put(`/interior/tenders/${tenderId}/vendors`, { vendorIds });
export const sendTender = (tenderId, body = {}) =>
  axiosInstance.post(`/interior/tenders/${tenderId}/send`, body);
export const getTenderComparison = (tenderId) =>
  axiosInstance.get(`/interior/tenders/${tenderId}/comparison`);
export const shortlistTender = (tenderId, tenderQuoteId) =>
  axiosInstance.post(`/interior/tenders/${tenderId}/shortlist`, { tenderQuoteId });
// Per-item award: pick the winning vendor quote line for one BOQ item.
export const awardTenderLine = (tenderId, tenderQuoteLineId) =>
  axiosInstance.post(`/interior/tenders/${tenderId}/award-line`, { tenderQuoteLineId });
// Finalize a consolidated tender once every item has a winner.
export const finalizeTender = (tenderId) =>
  axiosInstance.post(`/interior/tenders/${tenderId}/finalize`);
export const cancelTender = (tenderId) => axiosInstance.post(`/interior/tenders/${tenderId}/cancel`);

/* ---------------- Public (token-gated, no auth) ---------------- */
export const getPublicTenderForm = (token) => axiosInstance.get(`/interior/public/tenders/${token}`);
export const submitPublicQuote = (token, body) =>
  axiosInstance.post(`/interior/public/tenders/${token}/quote`, body);
export const declinePublicTender = (token) =>
  axiosInstance.post(`/interior/public/tenders/${token}/decline`);
